import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/dashboard/Dashboard';
import LeadList from './components/leads/LeadList';
import AddLead from './components/leads/AddLead';
import ViewLead from './components/leads/ViewLead';
import EditLead from './components/leads/EditLead';
import AdminDashboard from './components/admin/AdminDashboard';
import BookDemo from './components/demo/BookDemo';
import { LeadProvider } from './contexts/LeadContext';
// Import order - CRITICAL
import './styles/theme.css';
import './styles/App.css';
import './styles/components.css';
import './styles/documents.css';
import './styles/LeadPanel.css';
import './styles/BulkImport.css';
import './styles/Dashboard.css';   

function App() {
  return (
    <AuthProvider>
      <LeadProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/leads" element={<PrivateRoute><LeadList /></PrivateRoute>} />
            <Route path="/leads/add" element={<PrivateRoute><AddLead /></PrivateRoute>} />
            <Route path="/leads/:id" element={<PrivateRoute><ViewLead /></PrivateRoute>} />
            <Route path="/leads/:id/edit" element={<PrivateRoute><EditLead /></PrivateRoute>} />
            <Route path="/leads/:id/demo" element={<PrivateRoute><BookDemo /></PrivateRoute>} />
            <Route path="/admin/*" element={<PrivateRoute adminOnly><AdminDashboard /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </LeadProvider>
    </AuthProvider>
  );
}

function PrivateRoute({ children, adminOnly = false }) {
  const { isAuthenticated, loading, user } = useAuth();
  
  if (loading) return <div className="loading">Loading...</div>;
  
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  
  if (adminOnly && user?.role !== 'Admin') {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}

export default App;